import React from "react";
import { Box, IconButton, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router-dom";

export default function DemoVideo() {
  const history = useHistory();
  const demoVideo = "/images/home.mp4?v=20260330_1";

  return (
    <Box
      style={{
        maxWidth: 1100,
        margin: "0 auto",
        padding: "16px",
      }}
    >
      <Box display="flex" alignItems="center" style={{ gap: 10, marginBottom: 12 }}>
        <IconButton
          aria-label="Back"
          onClick={() => history.push("/montessori/home")}
          style={{ backgroundColor: "#0f3b62", color: "white" }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5" style={{ fontWeight: 700, color: "#0f3b62" }}>
          Watch Demo
        </Typography>
      </Box>

      <Box
        style={{
          borderRadius: 12,
          overflow: "hidden",
          border: "1px solid rgba(15, 59, 98, 0.18)",
          boxShadow: "0 8px 24px rgba(15, 59, 98, 0.12)",
          background: "#000",
        }}
      >
        <video
          src={demoVideo}
          controls
          autoPlay
          playsInline
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      </Box>
    </Box>
  );
}

